import React from 'react';
import {useState} from 'react';
import {TableHeaderRow} from '@devexpress/dx-react-grid-material-ui';
import {Popper} from '@material-ui/core';
import {MoreIcon, FixButton, useStyles} from './style'

export const TableHeaderContent = ({
                                       column,
                                       children,
                                       ...restProps
                                   }, fixColumn = null, leftColumns = [], editValues, fixedColumns = true) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => setAnchorEl(anchorEl ? null : event.currentTarget)
    const changeColumns = (columnName) => fixColumn(columnName.name)
    const onEditValues = (columnName) => editValues(columnName)

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    return (
        <>
            <TableHeaderRow.Content
                column={column}
                {...restProps}>
                {children}
                {fixedColumns && (
                    <MoreIcon onClick={handleClick} aria-describedby={id}/>
                )}
            </TableHeaderRow.Content>

            <Popper style={{zIndex: 1000}} id={id} open={open} anchorEl={anchorEl}>
                <div className={classes.paper}>
                    {fixedColumns && (
                        <FixButton variant="contained" onClick={() => changeColumns(column)}
                                   color="disabled"> {!leftColumns.includes(column.name) ? `Fixar coluna` : `Desfixar coluna`} </FixButton>
                    )}
                </div>
            </Popper>

        </>
    )
};
